import { type PhotoEvidenceItem, PhotoEvidenceList } from '../PhotoEvidenceList/PhotoEvidenceList';
const MAX_IMAGES = 5;
export const CardGallery = ({ images }: { images: PhotoEvidenceItem[] }) => {
  if (!images.length) {
    return null;
  }

  const priorityImage = Object.assign({}, images[0]);
  priorityImage.cols = 2;
  priorityImage.rows = 2;
  const priorityImages = [priorityImage, ...images.slice(1, MAX_IMAGES)];

  return (
    <PhotoEvidenceList
      evidencePhotos={priorityImages}
      direction="row"
      slotProps={{
        imageList: {
          cols: 2,
          gap: 10,
          variant: 'quilted',
        },
      }}
    />
  );
};
